import { apiFetch } from './http';

export async function getNotifications({ limit } = {}) {
  const params = new URLSearchParams();
  if (limit) params.set('limit', limit);
  const query = params.toString();
  const data = await apiFetch(`/notifications${query ? `?${query}` : ''}`);
  return Array.isArray(data?.notifications) ? data.notifications : [];
}

export async function markNotificationRead(id) {
  if (!id) throw new Error('Notification id is required');
  const data = await apiFetch(`/notifications/${id}/read`, { method: 'POST' });
  return data?.notification || null;
}

export async function markAllNotificationsRead() {
  return apiFetch('/notifications/read-all', { method: 'POST' });
}

export async function deleteNotification(id) {
  if (!id) throw new Error('Notification id is required');
  return apiFetch(`/notifications/${id}`, { method: 'DELETE' });
}

export async function clearNotifications() {
  return apiFetch('/notifications', { method: 'DELETE' });
}
